module.exports = __webpack_public_path__ + "static/media/hero.141b2918.glb";